(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-combo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vx-combo')) {
    customElements.define(
      'vx-combo',
      class VxCombo extends HTMLElement {
        connectedCallback() {
          if (this._ready) return;
          this._ready = true;
          try {
            this.products = JSON.parse(this.querySelector('[data-vx-combo-data]').textContent);
          } catch (e) {
            return;
          }
          this.pct = Number(this.dataset.pct) || 0;
          this.fixed = Number(this.dataset.fixed) || 0;
          this.moneyFormat = this.dataset.money || '${{amount}}';
          this.btn = this.querySelector('[data-add]');
          this.btnLabel = this.querySelector('[data-btn-label]');
          this.defaultLabel = this.btnLabel.textContent;
          this.querySelectorAll('.vx-combo__select').forEach((sel) => sel.addEventListener('change', () => this.update()));
          this.btn.addEventListener('click', () => this.add());
          this.update();
        }

        money(cents) {
          const n = (cents / 100).toFixed(2);
          return this.moneyFormat
            .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n.replace('.', ','))
            .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
            .replace(/\{\{\s*amount\s*\}\}/, n);
        }

        selected(i) {
          const p = this.products[i];
          const sels = Array.from(this.querySelectorAll('.vx-combo__select[data-product="' + i + '"]'));
          if (!sels.length) return p.variants[0];
          const wanted = sels.map((s) => s.value);
          return p.variants.find((v) => v.options.every((o, k) => o === wanted[k])) || null;
        }

        update() {
          const v = [this.selected(0), this.selected(1)];
          v.forEach((variant, i) => {
            const img = this.querySelector('[data-img="' + i + '"] img');
            const src = variant && variant.image;
            if (img && src) {
              img.src = src;
              img.removeAttribute('srcset');
            }
          });
          const ok = v.every((x) => x && x.available);
          this.btn.disabled = !ok;
          this.btnLabel.textContent = ok ? this.defaultLabel : !v.every(Boolean) ? 'No disponible' : 'Agotado';
          if (!v.every(Boolean)) return;
          // Igual que Shopify: descuento por unidad truncado al céntimo; con precio fijo, el total es ese precio
          // y el ahorro se cuenta sobre el precio real (tachado)
          let regular = 0;
          let total = 0;
          v.forEach((x) => {
            regular += this.fixed && x.compare > x.price ? x.compare : x.price;
            total += x.price - Math.floor((x.price * this.pct) / 100);
          });
          if (this.fixed) total = this.fixed;
          this.querySelector('[data-total]').textContent = this.money(total);
          const reg = this.querySelector('[data-regular]');
          if (reg) reg.textContent = this.money(regular);
          const save = this.querySelector('[data-save]');
          if (save) save.textContent = this.money(regular - total);
        }

        add() {
          const v = [this.selected(0), this.selected(1)];
          if (this.busy || !v.every((x) => x && x.available)) return;
          this.busy = true;
          this.btn.classList.add('is-loading');
          const err = this.querySelector('[data-error]');
          err.hidden = true;
          const drawer = document.querySelector('cart-drawer');
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: v.map((x) => ({ id: x.id, quantity: 1 })),
              sections: ['cart-drawer', 'cart-icon-bubble'],
              sections_url: window.location.pathname,
            }),
          })
            .then((r) => r.json())
            .then((data) => {
              if (data.status) {
                err.textContent = data.description || data.message || 'No se pudo añadir al carrito.';
                err.hidden = false;
                return;
              }
              if (window.publish && window.PUB_SUB_EVENTS) {
                window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'vx-combo', cartData: data });
              }
              if (drawer && typeof drawer.renderContents === 'function') {
                drawer.classList.remove('is-empty');
                drawer.renderContents(data);
              } else {
                window.location.href = root + 'cart';
              }
            })
            .catch(() => {
              err.textContent = 'No se pudo añadir al carrito. Inténtalo de nuevo.';
              err.hidden = false;
            })
            .finally(() => {
              this.busy = false;
              this.btn.classList.remove('is-loading');
            });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vx-welcome-popup"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vx-welcome-popup')) {
    customElements.define(
      'vx-welcome-popup',
      class VxWelcomePopup extends HTMLElement {
        connectedCallback() {
          if (this._ready) return;
          this._ready = true;
          this.key = this.dataset.key;
          const design = window.Shopify && window.Shopify.designMode;
          if (!design && this.seen()) return;

          this.querySelectorAll('[data-wp-close]').forEach((b) => b.addEventListener('click', () => this.close()));
          this.querySelector('[data-wp-next]').addEventListener('click', () => this.go(2));
          this.querySelector('form[data-step="2"]').addEventListener('submit', (e) => this.submit(e));
          this.querySelector('[data-wp-copy]').addEventListener('click', () => this.copy());
          document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !this.hidden) this.close(); });

          if (design) {
            this.hidden = false;
            return;
          }
          setTimeout(() => {
            this.hidden = false;
            this.mark('shown');
          }, (Number(this.dataset.delay) || 0) * 1000);
        }

        seen() {
          try { return !!localStorage.getItem(this.key); } catch (e) { return false; }
        }

        mark(v) {
          try { localStorage.setItem(this.key, v); } catch (e) {}
        }

        go(n) {
          this.querySelectorAll('.vx-wp__step').forEach((el) => (el.hidden = el.dataset.step !== String(n)));
          const first = this.querySelector('.vx-wp__step[data-step="' + n + '"] input');
          if (first) first.focus();
        }

        close() {
          this.hidden = true;
          this.mark('closed');
        }

        submit(e) {
          e.preventDefault();
          const form = e.currentTarget;
          const name = form.first_name.value.trim();
          const email = form.email.value.trim();
          const err = this.querySelector('[data-wp-error]');
          if (!name || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            err.hidden = false;
            return;
          }
          err.hidden = true;
          const btn = form.querySelector('button[type="submit"]');
          btn.disabled = true;
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const body = new URLSearchParams();
          body.set('form_type', 'customer');
          body.set('utf8', '✓');
          body.set('contact[email]', email);
          body.set('contact[first_name]', name);
          body.set('contact[tags]', 'newsletter, desplegable-bienvenida');
          body.set('contact[accepts_marketing]', 'true');
          const code = encodeURIComponent(this.dataset.code);
          // Guardar la suscriptora en Clientes y dejar el código aplicado al carrito
          Promise.allSettled([
            fetch(root + 'contact', { method: 'POST', body: body, credentials: 'same-origin' }),
            fetch(root + 'discount/' + code, { credentials: 'same-origin' }),
          ]).finally(() => {
            btn.disabled = false;
            this.mark('claimed');
            this.go(3);
          });
        }

        copy() {
          const note = this.querySelector('.vx-wp__note');
          const done = () => { if (note && note.dataset.wpCopiedText) note.textContent = note.dataset.wpCopiedText; };
          if (navigator.clipboard) navigator.clipboard.writeText(this.dataset.code).then(done, done);
          else done();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
